//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    slidesNo: {
      type: Number,
      default: 3,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sliderOptions: {
        arrows: true,
        slidesToShow: this.slidesNo,
        infinite: false,
        slidesToScroll: 1,
        adaptiveHeight: true,
        centerMode: false,
        dots: false,
        nextArrow:
          '<div class="infinite-next-btn pr-md-5"><span class="icon-arrow-right slider-next"></span></div>',
        prevArrow:
          '<div class="infinite-prev-btn"><span class="icon-arrow-left slider-prev"></span></div>',
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
   mounted() {
    this.$store.dispatch("getVideos", { page: 1, size: 10 });
    //youtube api script
    this.initiateYTapi();
  },
  computed: {
    videoList() {
      return this.$store.state.videos;
    },
  },
  watch: {
    videoList() {
      this.initiateYTPlayer(
        this.validateYoutubeURL(this.videoList[this.currentIndex].youtube_url)
      );
    },
  },
  methods: {
    useMoment(newsDate) {
      if (newsDate != "") {
        return this.$moment(newsDate).format("MMM DD, YYYY");
      }
    },

    truncate(str, no_words) {
      if (str && no_words != "") {
        if (
          str
            .replace(/(^\s*)|(\s*$)/gi, "")
            .replace(/[ ]{2,}/gi, " ")
            .replace(/\n /, "\n")
            .split(" ").length > no_words
        ) {
          return str.split(" ").splice(0, no_words).join(" ") + "...";
        } else {
          return str;
        }
      }
    },

  validateYoutubeURL(url) {
      var p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
      var matches = url.match(p);
      if (matches) {
        return matches[1];
      }
      return false;
    },
    initiateYTapi() {
      if (this.ytApiTag == null) {
        this.ytApiTag = document.createElement("script");
        this.ytApiTag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(this.ytApiTag, firstScriptTag);
      }
    },
    updateVideo(id) {
      let currentYurl = this.validateYoutubeURL(id);
      this.ytPlayer.loadVideoById(currentYurl);
    },
    initiateYTPlayer(vId) {
      this.$refs.videolist.style.height =
        this.$refs.videoplayer.offsetHeight + "px";
      this.ytPlayer = new YT.Player("youtubeListPlayer", {
        height: "390",
        width: "640",
        videoId: vId,
        events: {
          onReady: this.onPlayerReady,
          //'onStateChange': onPlayerStateChange
        },
      });
    },
    onPlayerReady(event) {
      // event.target.playVideo();

      //this.lastVideo = index;
      setTimeout(() => {
        this.loading = false;
      }, 100);
    },



  },
};
